import type { PageResult } from '@jiaofa/api-types'
import { request } from './request'

export type ComplaintType = 'COMPLAINT' | 'SUGGESTION' | 'FEEDBACK'
export type ComplaintStatus = 'PENDING' | 'PROCESSING' | 'RESOLVED'

export interface AdminComplaint {
  id: string
  orderId?: string
  type: ComplaintType | string
  content: string
  status?: ComplaintStatus
  reply?: string
  createdAt?: string
}

export interface ReplyComplaintParams {
  id: string
  reply: string
}

export interface UpdateComplaintStatusParams {
  id: string
  status: ComplaintStatus
}

export const fetchComplaints = async (params: { page?: number; pageSize?: number }): Promise<PageResult<AdminComplaint>> =>
  request<PageResult<AdminComplaint>>({
    url: '/complaints',
    method: 'GET',
    params,
  })

export const replyComplaint = async (params: ReplyComplaintParams): Promise<void> =>
  request<void>({
    url: '/complaints/reply',
    method: 'POST',
    data: params,
  })

export const updateComplaintStatus = async (params: UpdateComplaintStatusParams): Promise<void> =>
  request<void>({
    url: '/complaints/status',
    method: 'POST',
    data: params,
  })
